import { Link } from 'react-router-dom';
import heroBg   from '../images/home5.png';
import imgRide  from '../images/Ride.jpg';
import imgTrain from '../images/Strength.jpg';
import imgJump  from '../images/Jump.jpg';
import imgFlow  from '../images/Flow.jpg';
import imgPilates from '../images/Pilates.jpg';
import imgBarre   from '../images/Barre.jpg';
import Iframe from 'react-iframe'

const DISCIPLINES = [
  { title: 'Encuentra tu energía',      name: 'Ride',     image: imgRide,    soon: false },
  { title: 'Desarrolla tu fuerza',      name: 'Train',    image: imgTrain,   soon: false },
  { title: 'Suelta y libera',           name: 'Jump',     image: imgJump,    soon: true  },
  { title: 'Fluye con el movimiento',   name: 'Flow',     image: imgFlow,    soon: true  },
  { title: 'Fortalece con control',     name: 'Pilates',  image: imgPilates, soon: true  },
  { title: 'Estiliza tu cuerpo',        name: 'Barre',    image: imgBarre,   soon: true  },
];

function App() {
  return (
    <>
      {/* ── Hero ─────────────────────────────────────────────── */}
      <div className="hero-section" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="hero-overlay" />
        <div className="hero-content">
          <h1 className="hero-title">
            Disciplina. Energía.<br />
            Transformación. Comunidad.
          </h1>
          <p className="hero-subtitle">
            En Psycle construimos disciplina, energía y presencia a través de
            experiencias que transforman cuerpo y mente.
          </p>
          <div className="hero-buttons">
            <Link to="/reservar-clases" className="hero-btn hero-btn--filled">
              Reserva tu experiencia
            </Link>
            {/* <Link to="/sobre-psycle" className="hero-btn hero-btn--outline">
              Descubre Psycle
            </Link> */}
          </div>
        </div>
      </div>

      {/* ── Section 2: No es solo entrenar ───────────────────── */}
      <div className="statement-section">
        <div className="statement-left">
          <h2 className="statement-title">
            <span className="statement-line">NO SOLO ES             <span className="statement-line">
              <span className="statement-highlight">ENTRENAR.</span>
            </span></span>

            <span className="statement-line">ES CÓMO QUIERES</span>
            <span className="statement-line">
              <span className="statement-highlight">SENTIRTE.</span>
            </span>
          </h2>
        </div>

        <div className="statement-right">
          <p className="statement-text">
            Un espacio donde el movimiento se convierte en energía compartida.
            Entrenas, te conectas y evolucionas.
          </p>
          <p className="statement-text">
            Nuestras clases diseñadas para retarte, enfocarte y hacerte sentir mejor.
          </p>
          <Link to="/comprar-clases" className="hero-btn hero-btn--filled statement-cta">
            Comienza tu proceso
          </Link>
        </div>
      </div>

      {/* ── Section 3: Disciplinas ────────────────────────────── */}
      <div className="disciplines-section">
        <div className="disciplines-grid">
          {DISCIPLINES.map((d) => (
            <div
              key={d.name}
              className="discipline-card"
              style={{ backgroundImage: `url(${d.image})` }}
            >
              <div className="discipline-overlay" />
              <div className="discipline-content">
                <div className="discipline-text">
                  <h2 className="discipline-title">{d.title}</h2>
                  <p className="discipline-name">{d.name}</p>
                </div>
                {d.soon ? (
                  <span className="discipline-soon">Próximamente</span>
                ) : (
                  <Link to="/reservar-clases" className="discipline-btn">
                    Reserva ahora
                  </Link>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="info-section">
        <h1 className='hero-title'>Ubicación</h1>
        <div className="row container m0a">
          <div className="address-info col-sm-12">
            <div >
              <p>Gral. Jeronimo Treviño, Cabecera Municipal,</p>
              <p> Apodaca Centro, 66600 Cdad. Apodaca, N.L.</p>
            </div>
          </div>

          <div className=' col-sm-12'>
            <Iframe url="https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=Gral.%20Jeronimo%20Trevi%C3%B1o,%20Cabecera%20Municipal%20(Apodaca),%20Apodaca%20Centro,%2066600%20Cdad.%20Apodaca,%20N.L.+(Psycle)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
              width="100%"
              height="400px"
              id=""
              className=""
              display="block"
              maxWidth="1200px"
              position="relative"/>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;